import(/* webpackMode: "eager" */ "/build/src/app/common-error-alert.tsx");
import(/* webpackMode: "eager" */ "/build/src/app/document-search/components/document-search.tsx")